/* cozycloud Dawn theme — UI behavior (cart drawer, countdown, sticky, accordions, gallery, qty) */
(function(){
  function $(s,r){return (r||document).querySelector(s);}
  function $all(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}

  function toast(msg){
    var t=$('#cc-toast'); if(!t) return;
    t.setAttribute('role','status');t.setAttribute('aria-live','polite');
    t.textContent=msg; t.hidden=false; clearTimeout(t._t);
    t._t=setTimeout(function(){t.hidden=true;},2200);
  }

  /* ---------- Cart drawer ---------- */
  function openCart(){var d=$('#cc-cart-drawer'),s=$('#cc-cart-scrim');if(d){d.classList.add('is-open');}if(s){s.hidden=false;}document.body.style.overflow='hidden';}
  function closeCart(){var d=$('#cc-cart-drawer'),s=$('#cc-cart-scrim');if(d){d.classList.remove('is-open');}if(s){s.hidden=true;}document.body.style.overflow='';}
  window.ccOpenCart=openCart; window.ccCloseCart=closeCart;
  window.ccRefreshCart=function(){return refresh();};
  window.ccFormatMoney=formatMoney;

  function renderCart(cart){
    var count=$all('[data-cart-count]'); count.forEach(function(el){el.textContent=cart.item_count;});
    var body=$('#cc-cart-items'), foot=$('#cc-cart-foot'), empty=$('#cc-cart-empty');
    if(!body) return;
    if(cart.item_count===0){ if(empty)empty.hidden=false; if(foot)foot.hidden=true; body.querySelectorAll('[data-line]').forEach(function(n){n.remove();}); if(typeof window.ccuRefresh==='function'){window.ccuRefresh(cart);} return; }
    if(empty)empty.hidden=true; if(foot)foot.hidden=false;
    body.querySelectorAll('[data-line]').forEach(function(n){n.remove();});
    cart.items.forEach(function(it,i){
      var row=document.createElement('div'); row.setAttribute('data-line','');
      row.style.cssText='display:flex;gap:14px;align-items:center;padding:16px 0;border-bottom:1.5px solid rgba(22,20,15,.14)';
      var _u=it.url||("/products/"+it.handle);row.innerHTML='<a href="'+_u+'" style="width:58px;height:58px;border:1.5px solid var(--ink);border-radius:10px;overflow:hidden;flex:none;background:var(--mint);display:block">'+(it.image?'<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/,'_120x$1$2')+'" alt="" style="width:100%;height:100%;object-fit:cover">':'')+'</a>'+
        '<div style="flex:1;min-width:0"><a href="'+_u+'" style="font-family:\'Bricolage Grotesque\',sans-serif;font-weight:700;font-size:15px;line-height:1.15;color:inherit;text-decoration:none;display:block">'+it.product_title+'</a>'+
        '<div style="font-family:\'JetBrains Mono\',monospace;font-size:11px;color:rgba(22,20,15,.6);margin-top:3px">'+(it.variant_title||'')+'</div>'+
        (it.handle==='intimacy-support-cushion'?'<div class="cc-bonusline"><i>&#10003;</i><img src="https://cdn.shopify.com/s/files/1/0826/3594/8341/files/cozy-guide-cover-1.png?v=1791566024&width=90" alt="" width="45" height="62"><img src="https://cdn.shopify.com/s/files/1/0826/3594/8341/files/cozy-guide-cover-2.png?v=1791566024&width=90" alt="" width="45" height="62"><img src="https://cdn.shopify.com/s/files/1/0826/3594/8341/files/cozy-guide-cover-3.png?v=1791566024&width=90" alt="" width="45" height="62"><s>3 bonus guides included</s><b>FREE</b></div>':'')+
        '<div class="cc-qtyrow"><div class="cc-qty"><button type="button" data-qty="'+(i+1)+'" data-line-key="'+it.key+'" data-d="-1" aria-label="Decrease">&minus;</button><span>'+it.quantity+'</span><button type="button" data-qty="'+(i+1)+'" data-line-key="'+it.key+'" data-d="1" aria-label="Increase">+</button></div>'+
        '<button data-remove="'+(i+1)+'" data-line-key="'+it.key+'" style="cursor:pointer;background:none;border:none;font-family:\'JetBrains Mono\',monospace;font-size:11px;color:rgba(22,20,15,.55);text-decoration:underline">Remove</button></div></div>'+
        '<div style="text-align:right;flex:none"><div style="font-family:\'JetBrains Mono\',monospace;font-size:13px">'+formatMoney(it.final_line_price)+'</div></div>';
      body.appendChild(row);
    });
    var sub=$('#cc-cart-subtotal'); if(sub)sub.textContent=formatMoney(cart.total_price);
    var coBtn=$('#cc-checkout-amt'); if(coBtn)coBtn.textContent=formatMoney(cart.total_price);
  
    if(typeof window.ccuRefresh==='function'){window.ccuRefresh(cart);}
  }

  var cartChangePending=false;
  function changeCart(line,quantity){
    if(cartChangePending) return;
    cartChangePending=true;
    var controls=$all('#cc-cart-items [data-qty], #cc-cart-items [data-remove]');
    var drawer=$('#cc-cart-drawer'); if(drawer)drawer.setAttribute('aria-busy','true');
    controls.forEach(function(button){button.disabled=true;});
    var payload={quantity:quantity}; if(typeof line==='string')payload.id=line;else payload.line=line;
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)}).then(function(r){
      return r.json().catch(function(){throw new Error('Unable to update your cart. Please try again.');}).then(function(cart){
        if(!r.ok || !cart || !Array.isArray(cart.items))throw new Error(cart && typeof cart.description==='string'?cart.description:'Unable to update your cart. Please try again.');
        renderCart(cart);
        if(/\/cart\/?$/.test(window.location.pathname))window.location.reload();
        return cart;
      });
    }).catch(function(error){toast(error.message||'Unable to update your cart. Please check your connection and try again.');}).finally(function(){
      cartChangePending=false; if(drawer)drawer.removeAttribute('aria-busy');
      controls.forEach(function(button){button.disabled=false;});
    });
  }

  function formatMoney(cents){
    var fmt=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'USD';
    try{return new Intl.NumberFormat(undefined,{style:'currency',currency:fmt}).format(cents/100);}catch(e){return '$'+(cents/100).toFixed(2);}
  }

  function refresh(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){if(!r.ok)throw new Error('Unable to refresh your cart. Please open your cart before trying again.');return r.json();}).then(function(cart){if(!cart||!Array.isArray(cart.items))throw new Error('Unable to confirm your cart. Please open your cart before trying again.');renderCart(cart);return cart;});}

  document.addEventListener('click',function(e){
    var add=e.target.closest('[data-cc-add]');
    if(add){
      e.preventDefault();
      if(add.getAttribute('aria-busy')==='true'||add.disabled||add.getAttribute('aria-disabled')==='true')return;
      var form=add.closest('form[action*="/cart/add"]')||add.closest('form');
      var body; var headers={'Accept':'application/json'};
      if(form){ body=new FormData(form); }
      else { body=JSON.stringify({id:add.getAttribute('data-cc-add'),quantity:1}); headers['Content-Type']='application/json'; }
      add.setAttribute('aria-busy','true');
      var addedLines;
      fetch('/cart/add.js',{method:'POST',headers:headers,body:body}).then(function(r){
        return r.json().catch(function(){throw new Error('Unable to confirm the item was added. Please check your cart before trying again.');}).then(function(data){
          if(!r.ok||data.status||data.errors)throw new Error(typeof data.description==='string'?data.description:'Unable to add this item. Please check your selection and try again.');
          addedLines=data.items||[data];
          if(!addedLines.length||!addedLines.every(function(line){return line&&line.id&&line.key&&Number(line.quantity)>0;}))throw new Error('Unable to confirm the item was added. Please check your cart before trying again.');
          return refresh();
        });
      }).then(function(cart){
        if(!addedLines.every(function(added){return cart.items.some(function(line){return line.key===added.key&&String(line.id)===String(added.id)&&Number(line.quantity)>0;});}))throw new Error('Unable to confirm the item in your cart. Please check your cart before trying again.');
        openCart();toast('Added to cart');
      }).catch(function(error){toast(error.message||'Unable to add this item. Please check your connection and try again.');}).finally(function(){add.removeAttribute('aria-busy');});
      return;
    }
    if(e.target.closest('[data-cc-open-cart]')){e.preventDefault();openCart();return;}
    if(e.target.closest('[data-cc-close-cart]')){e.preventDefault();closeCart();return;}
    var q=e.target.closest('#cc-cart-items [data-qty][data-d]');
    if(q){e.preventDefault();
      var row=q.parentElement, cur=parseInt(row.querySelector('span').textContent,10)||1;
      var next=cur+parseInt(q.getAttribute('data-d'),10);
      if(next<0)next=0;
      changeCart(q.getAttribute('data-line-key')||parseInt(q.getAttribute('data-qty'),10),next);return;}
    var rm=e.target.closest('#cc-cart-items [data-remove]');
    if(rm){e.preventDefault();changeCart(rm.getAttribute('data-line-key')||parseInt(rm.getAttribute('data-remove'),10),0);return;}
    var acc=e.target.closest('[data-cc-acc]');
    if(acc){var b=acc.nextElementSibling;var open=acc.getAttribute('aria-expanded')==='true';acc.setAttribute('aria-expanded',open?'false':'true');if(b)b.hidden=open;var sign=acc.querySelector('[data-sign]');if(sign)sign.textContent=open?'+':'\u2013';return;}
    var thumb=e.target.closest('[data-cc-thumb]');
    if(thumb){var main=$('#cc-gallery-main');if(main){main.style.backgroundImage=thumb.style.backgroundImage;main.style.background=thumb.style.background;}$all('[data-cc-thumb]').forEach(function(t){t.style.outline='none';});thumb.style.outline='2px solid var(--ink)';return;}
    var pdpQty=e.target.closest('[data-qty="inc"], [data-qty="dec"]');
    if(pdpQty){e.preventDefault();var inp=$('#cc-qty');if(inp){var v=Math.max(1,parseInt(inp.value,10)||1);inp.value=pdpQty.getAttribute('data-qty')==='inc'?v+1:Math.max(1,v-1);}return;}
  });

  /* ---------- Countdown ---------- */
  function tick(){
    var els=$all('[data-countdown]'); if(!els.length) return;
    function p(n){return (n<10?'0':'')+n;}
    els.forEach(function(el){
      var end=parseInt(el.getAttribute('data-end')||'0',10)*1000; if(!end) return;
      var rem=end-Date.now();
      if(rem<=0){ if(el.parentElement) el.parentElement.style.display='none'; return; }
      var s=Math.floor(rem/1000),d=Math.floor(s/86400),h=Math.floor((s%86400)/3600),m=Math.floor((s%3600)/60),sec=s%60;
      el.textContent=(d>0?d+'d ':'')+p(h)+':'+p(m)+':'+p(sec);
    });
  }
  setInterval(tick,1000); tick();

  /* ---------- Sticky bars on scroll ---------- */
  function onScroll(){var on=window.scrollY>640;$all('[data-cc-sticky]').forEach(function(el){el.hidden=!on;});}
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();

  document.addEventListener('DOMContentLoaded',function(){ if(window.location.search.indexOf('cart_opened')>-1)openCart(); refresh().catch(function(){}); });
})();

